/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { UserTaskStatus } from './UserTaskStatus';
import {
    UserTaskStatusFromJSON,
    UserTaskStatusFromJSONTyped,
    UserTaskStatusToJSON,
    UserTaskStatusToJSONTyped,
} from './UserTaskStatus';

/**
 * 
 * @export
 * @interface UpdateUserTaskRequest
 */
export interface UpdateUserTaskRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateUserTaskRequest
     */
    assigneeUserId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {UserTaskStatus}
     * @memberof UpdateUserTaskRequest
     */
    status: UserTaskStatus | null;
}



/**
 * Check if a given object implements the UpdateUserTaskRequest interface.
 */
export function instanceOfUpdateUserTaskRequest(value: object): value is UpdateUserTaskRequest {
    if (!('assigneeUserId' in value) || value['assigneeUserId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateUserTaskRequestFromJSON(json: any): UpdateUserTaskRequest {
    return UpdateUserTaskRequestFromJSONTyped(json, false);
}

export function UpdateUserTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assigneeUserId': ActorActivityRecordActorUserIdFromJSON(json['assigneeUserId']),
        'status': UserTaskStatusFromJSON(json['status']),
    };
}

export function UpdateUserTaskRequestToJSON(json: any): UpdateUserTaskRequest {
    return UpdateUserTaskRequestToJSONTyped(json, false);
}

export function UpdateUserTaskRequestToJSONTyped(value?: UpdateUserTaskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assigneeUserId': ActorActivityRecordActorUserIdToJSON(value['assigneeUserId']),
        'status': UserTaskStatusToJSON(value['status']),
    };
}

